import React, { useState } from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const InteractiveServiceFinder = () => {
  const [location, setLocation] = useState('');
  const [serviceType, setServiceType] = useState('');
  const [showResults, setShowResults] = useState(false);

  const serviceOptions = [
    { value: 'solar', label: 'Zonnepanelen specialisten' },
    { value: 'heatpump', label: 'Warmtepomp monteurs' },
    { value: 'battery', label: 'Batterijsysteem technici' },
    { value: 'groundwork', label: 'Grondwerken specialisten' },
    { value: 'truck-drivers', label: 'Vrachtwagen chauffeurs' },
    { value: 'plumbing', label: 'Loodgieter werkzaamheden' },
    { value: 'crane-operators', label: 'Kraan operators' },
    { value: 'pavers', label: 'Stratenmakers' },
    { value: 'maintenance', label: 'Onderhoudsmonteurs' },
    { value: 'ventilation', label: 'Ventilatie specialisten' },
    { value: 'electrical', label: 'Elektromonteurs' }
  ];

  const handleSearch = (e) => {
    e?.preventDefault();
    if (location && serviceType) {
      setShowResults(true);
    }
  };

  return (
    <section id="finder" className="py-20 md:py-28 bg-[#0A0A0A] relative overflow-hidden">
      <div className="absolute top-0 right-0 w-80 h-80 rounded-full blur-[140px] opacity-5" style={{ background: '#00E5A0' }} />
      <div className="max-w-6xl mx-auto px-6 lg:px-8 relative z-10">
        <div className="max-w-3xl mx-auto">
          <motion.div
            className="text-center mb-10"
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <motion.p className="text-xs font-body font-medium tracking-[0.2em] uppercase mb-4" style={{ color: '#00E5A0' }}>
              — Zoeken
            </motion.p>
            <h2 className="text-4xl md:text-5xl font-heading font-bold text-white mb-4 leading-tight">
              Vind de juiste vakman
            </h2>
            <p className="text-base" style={{ color: '#888888' }}>
              Selecteer je locatie en type vakman voor directe matches
            </p>
          </motion.div>

          <motion.div
            className="p-8"
            style={{ background: '#0D0D0D', border: '1px solid #1A1A1A' }}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <form onSubmit={handleSearch} className="space-y-5">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-xs font-body font-semibold tracking-wide uppercase mb-2" style={{ color: '#555555' }}>Locatie</label>
                  <div className="relative">
                    <Icon name="MapPin" size={16} className="absolute left-3 top-1/2 -translate-y-1/2" color="#555555" />
                    <input
                      type="text"
                      placeholder="Bijv. Amsterdam, Rotterdam"
                      value={location}
                      onChange={(e) => setLocation(e?.target?.value)}
                      className="w-full pl-9 pr-4 py-3 text-sm font-body text-white placeholder-[#444] outline-none transition-colors"
                      style={{ background: '#141414', border: '1px solid #2A2A2A', borderRadius: '2px' }}
                      onFocus={e => e.target.style.borderColor = '#00E5A0'}
                      onBlur={e => e.target.style.borderColor = '#2A2A2A'}
                    />
                  </div>
                </div>
                <div>
                  <label className="block text-xs font-body font-semibold tracking-wide uppercase mb-2" style={{ color: '#555555' }}>Type vakman</label>
                  <select
                    value={serviceType}
                    onChange={(e) => setServiceType(e?.target?.value)}
                    className="w-full px-4 py-3 text-sm font-body text-white outline-none transition-colors"
                    style={{ background: '#141414', border: '1px solid #2A2A2A', borderRadius: '2px', color: serviceType ? '#fff' : '#444' }}
                    onFocus={e => e.target.style.borderColor = '#00E5A0'}
                    onBlur={e => e.target.style.borderColor = '#2A2A2A'}
                  >
                    <option value="" style={{ background: '#141414' }}>Selecteer een dienst</option>
                    {serviceOptions?.map((option) => (
                      <option key={option?.value} value={option?.value} style={{ background: '#141414' }}>{option?.label}</option>
                    ))}
                  </select>
                </div>
              </div>
              <motion.button
                type="submit"
                className="w-full py-3 text-sm font-body font-semibold transition-all duration-200 flex items-center justify-center gap-2"
                style={{ background: location && serviceType ? '#00E5A0' : '#1A1A1A', color: location && serviceType ? '#0A0A0A' : '#444444', borderRadius: '2px' }}
                disabled={!location || !serviceType}
                whileHover={location && serviceType ? { scale: 1.01 } : {}}
                whileTap={location && serviceType ? { scale: 0.99 } : {}}
              >
                <Icon name="Search" size={16} color={location && serviceType ? '#0A0A0A' : '#444444'} />
                Zoek beschikbare vakmensen
              </motion.button>
            </form>

            {showResults && (
              <motion.div
                className="mt-8 pt-8"
                style={{ borderTop: '1px solid #1A1A1A' }}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
              >
                <div className="flex items-center gap-3 mb-5">
                  <div className="w-8 h-8 rounded flex items-center justify-center" style={{ background: 'rgba(0,229,160,0.1)' }}>
                    <Icon name="CheckCircle" size={18} color="#00E5A0" />
                  </div>
                  <div>
                    <h4 className="text-sm font-body font-semibold text-white">
                      {Math.floor(Math.random() * 20) + 10} vakmensen gevonden
                    </h4>
                    <p className="text-xs" style={{ color: '#666666' }}>
                      in {location} voor {serviceOptions?.find(s => s?.value === serviceType)?.label}
                    </p>
                  </div>
                </div>
                <div className="space-y-2">
                  {[1, 2, 3]?.map((i) => (
                    <motion.div
                      key={i}
                      className="flex items-center justify-between p-4"
                      style={{ background: '#141414', border: '1px solid #1A1A1A' }}
                      initial={{ opacity: 0, x: -20 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ delay: i * 0.1 }}
                    >
                      <div className="flex items-center gap-3">
                        <div className="w-9 h-9 rounded-full flex items-center justify-center" style={{ background: '#1A1A1A' }}>
                          <Icon name="User" size={16} color="#00E5A0" />
                        </div>
                        <div>
                          <p className="text-sm font-body font-semibold text-white">Vakman #{i}</p>
                          <div className="flex items-center gap-2 text-xs" style={{ color: '#666666' }}>
                            <Icon name="Star" size={12} color="#00E5A0" />
                            <span>4.{8 + i}/5</span>
                            <span>·</span>
                            <span>{50 + i * 10}+ projecten</span>
                          </div>
                        </div>
                      </div>
                      <button className="text-xs font-body font-medium px-3 py-1.5 transition-colors" style={{ border: '1px solid #2A2A2A', color: '#888888', borderRadius: '2px' }}>
                        Bekijk profiel
                      </button>
                    </motion.div>
                  ))}
                </div>
              </motion.div>
            )}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default InteractiveServiceFinder;